export const invalidQtyProductsActions = {
  startLoader: "START_INVALID_STOCK_MODEL_QTY_PRODUCTS_LOADER",
  request: "REQUEST_INVALID_STOCK_MODEL_QTY_PRODUCTS",
  success: "INVALID_STOCK_MODEL_QTY_PRODUCTS_SUCCESS",
  failure: "INVALID_STOCK_MODEL_QTY_PRODUCTS_FAILURE",
  reset: "RESET_INVALID_STOCK_MODEL_QTY_PRODUCTS",
};

export const getInvalidOrders = (stockModelId, warehouseId) => {
  return {
    type: invalidQtyProductsActions.request,
    payload: { stockModelId, warehouse_id: warehouseId },
  };
};

export const getInvalidOrdersSuccess = (payload) => {
  return {
    type: invalidQtyProductsActions.success,
    payload,
  };
};

export const getInvalidOrdersFailure = (errorPayload) => {
  return {
    type: invalidQtyProductsActions.failure,
    payload: errorPayload,
  };
};

export const resetInvalidQtyProducts = () => ({
  type: invalidQtyProductsActions.reset,
});
